import DefaultPage from 'keycloakify/login/DefaultPage';
import type { KcContext } from 'keycloakify/login/KcContext';
import Template from 'keycloakify/login/Template';
import UserProfileFormFields from 'keycloakify/login/UserProfileFormFields';

import { useGetMsg } from 'src/shared/utils/kc-messages.js';

export interface DefaultKeycloakPageProps {
    kcContext: KcContext;
}

export const DefaultKeycloakPage = ({ kcContext }: DefaultKeycloakPageProps) => {
    const i18n = useGetMsg(kcContext);

    return (
        <DefaultPage
            kcContext={kcContext}
            Template={Template}
            i18n={i18n}
            doUseDefaultCss
            UserProfileFormFields={UserProfileFormFields}
            doMakeUserConfirmPassword
        />
    );
};
